<script setup>
  const { event } = defineProps(['event']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <div class="heading">
    <EventLogo small :event="event" />
    <h3>{{ event.fight_title }}</h3>
  </div>
  <h2>
    <FightTitleCombo>
      <template v-slot:whiteCorner>{{ event.white_corner?.last_name ?? 'TBD' }}</template>
      <template v-slot:blackCorner>{{ event.black_corner?.last_name ?? 'TBD' }}</template>
    </FightTitleCombo>
  </h2>
  <div class="footing">
    <h4><IconPlus />{{ useTournamentSize(event.size) }} {{ event.tournament_title }}</h4>
    <TickerTape v-if="event.tournament_fighter_names?.length" :items="event.tournament_fighter_names" class="ticker" />
  </div>
  <div class="footing secondary" v-if="event.second_tournament_title">
    <h4><IconPlus />{{ useTournamentSize(event.second_tournament_size) }} {{ event.second_tournament_title }}</h4>
    <TickerTape v-if="event.second_tournament_fighter_names?.length" :items="event.second_tournament_fighter_names" class="ticker" />
  </div>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .heading {
    margin: px(92) 0 px(32);

    display: flex;
    align-items: center;

    margin-bottom: px(24);
    gap: px(24);

    h3 {
      display: block;
    }
  }

  h3 {
    @include title-s;
    margin-bottom: -0.17em;

    display: none;
  }

  h2 {
  }

  .footing {
    display: flex;
    align-items: center;
    gap: px(13);

    margin: px(32) 0 px(22);

    h4 {
      display: flex;
      align-items: center;

      flex-shrink: 0;

      @include title-s;
      font-size: px(44);
      margin-bottom: -0.17em;

      gap: px(12);

      svg {
        margin-top: px(-6);
      }
    }

    .ticker {
      width: 100%;
    }

    &.secondary {
      margin-top: px(0) !important;
    }
  }

  @include break-medium {
    .heading {
      margin-top: px(109);
    }

    .footing {
      h4 {
        gap: px(9);
        svg {
          width: px(16);
          margin-top: px(-5);
        }
      }
    }
  }

  @include break-small {
    .heading {
      flex-direction: column;
      gap: px(8);

      margin-top: px(80);
      margin-bottom: px(28);
    }

    h3 {
      display: block;
      margin-top: 8px;
    }

    h2 {
      align-self: stretch;
    }

    .footing {
      flex-direction: column;
      margin: px(8) 0 0;

      h4 {
        font-size: px(32);
        gap: px(8);

        svg {
          width: px(10);
          margin-top: px(-4);
        }
      }

      .ticker {
        min-width: 100vw;
      }
    }
  }

  @include break-phone {
    .heading {
      margin-top: 22vw;
    }

    .footing {
      h4 {
        font-size: 8vw;
      }
    }
  }
</style>
